import { collectionEngineV1 } from '../apis.js';
const reqUltimateCreditors = collectionEngineV1('/ultimate-creditors');
export const getByCreditor = (creditorId) => reqUltimateCreditors('GET', `/?creditorId=${creditorId}`);
export const get = (id) => reqUltimateCreditors('GET', `/${id}`);
export const create = (creditorId, ultimateCreditor) => reqUltimateCreditors('POST', `/`, {
    body: { ...ultimateCreditor, creditorId },
});
export const update = (id, ultimateCreditor) => reqUltimateCreditors('PATCH', `/${id}`, { body: ultimateCreditor });
export const remove = (id) => reqUltimateCreditors('DELETE', `/${id}`);
//# sourceMappingURL=ultimate-creditors.js.map